module.exports = __webpack_public_path__ + "media/src/StayPackage/images/tree-fff99e1bcce0312a5cac2564513bc40d.svg";